import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';

import { ColumnForSelection } from 'src/app/shared/import/column-for-selection';
import { ImportProgressService } from 'src/app/shared/import/import-progress.service';
import { ImportStep } from 'src/app/shared/import/import-step';
import { DataService } from 'src/app/shared/network/data.service';
import { ProjectService } from 'src/app/shared/project/project.service';
import { BaseColumnSelectComponent } from '../base-column-selection.component';
import { ExistenceSettings } from '../../../shared/import/existence-settings';

@Component({
  templateUrl: './existence-column-selection.component.html',
  styleUrls: ['../../general.scss', '../column-selection.scss']
})
export class ExistenceColumnSelectComponent extends BaseColumnSelectComponent implements OnInit {
    projectId: string;
    columns: ColumnForSelection[];
    selectedColumn: ColumnForSelection;
    outcomeName: string;
    public oldControlValue: string;
    public newControlValue: string;

    loading = false;
    dataLoaded = false;

    form = new FormGroup({
        existenceFrmCtrl: new FormControl(),
    });

    constructor(private dataService: DataService, private activatedRoute: ActivatedRoute,
        private router: Router, private importProgressService: ImportProgressService, private projectService: ProjectService) {
        super();
    }

    ngOnInit(): void {
        this.activatedRoute.queryParams.subscribe((queryParams: any) => {
            let projectId = queryParams.projectId;
            if(projectId) {
                this.projectId = projectId;
                this.projectService.setProjectId(projectId);
                this.dataService.get<ExistenceSettings>('columnSelection/existence/' + projectId)
                    .then(resp => {
                        this.columns = resp.columns;
                        this.outcomeName = resp.outcomeName;
                        this.oldControlValue = resp.oldControlValue;
                        this.newControlValue = resp.newControlValue;
                        super.selectColumn(resp.columns.filter(c => c.isSelected)[0]);
                        this.form.controls.existenceFrmCtrl.setValue(resp.shouldBreakDown);
                        this.dataLoaded = true;
                    });
            }
        });
    }

    async save(jump: boolean) {
        if (this.loading) {
            return;
        }
        try {
            this.loading = true;
            await this.dataService.post('columnSelection/existence', {
                projectId: this.projectId,
                columnIndex: this.columns.indexOf(this.selectedColumn),
                shouldBreakDown: this.form.controls.existenceFrmCtrl.value,
                jump: jump,
            });
            this.importProgressService.setImportStep(ImportStep.dimensions);
            if (jump) {
                this.router.navigateByUrl('/select-columns-dimensions?projectId=' + this.projectId);
            } else {
                this.router.navigateByUrl('/select-column-reference?projectId=' + this.projectId);
            }
        } finally {
            this.loading = false;
        }
    }
}
